import { useRef, useState } from "react";
import { Camera, Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { errMsg } from "@/lib/api";

export function PhotoPick({ bx, value, onChange }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) return toast.error("A foto deve ter no máximo 10 MB");
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await bx.post("/photo", fd);
      onChange({ ...data, preview: URL.createObjectURL(file) });
    } catch (x) {
      toast.error(errMsg(x));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="space-y-2" data-testid="boy-photo-field">
      <p className="text-sm font-medium">Foto do pedido (opcional)</p>
      {value ? (
        <div className="flex items-center gap-3">
          <img src={value.preview} alt="Foto do pedido" className="h-20 w-20 rounded-lg border object-cover" data-testid="boy-photo-preview" />
          <Button variant="ghost" size="sm" onClick={() => onChange(null)} data-testid="boy-photo-remove"><Trash2 className="mr-2 h-4 w-4" />Remover</Button>
        </div>
      ) : (
        <Button variant="outline" onClick={() => ref.current?.click()} disabled={busy} data-testid="boy-photo-btn">
          {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Camera className="mr-2 h-4 w-4" />}Adicionar foto
        </Button>
      )}
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={pick} data-testid="boy-photo-input" />
    </div>
  );
}
